import FanduelGeneralErrorIcon from '@/features/Icons/ErrorIcons/FanduelGeneralErrorIcon';
import { IconProductType, IconSubTypeMapper } from '../types';
import FanduelOutOfFundsIcon from '@/features/Icons/ErrorIcons/OutOfFundsIcon';
import WarningIcon from '@/features/Icons/WarningIcon';
import GeneralErrorIcon from '@/features/Icons/ErrorIcons/GeneralErrorIcon';
import OutOfFundsErrorIcon from '@/features/Icons/ErrorIcons/OutOfFundsErrorIcon';
import PokerLogoPopupError from '@/features/Icons/ErrorIcons/PokerLogoPopupError';
import ResponsibleGamingIconDefault from '@/features/Icons/ErrorIcons/ResponsibleGamingIconDefault';
import { ERROR_TYPE, POPUP_TYPES } from '@/features/Popup/constants';
import ResponsibleGamingIconNJ from '@/features/Icons/ErrorIcons/ResponsibleGamingIconNJ';
import ResponsibleGamingIconPA from '@/features/Icons/ErrorIcons/ResponsibleGamingIconPA';
import ResponsibleGamingIconWV from '@/features/Icons/ErrorIcons/ResponsibleGamingIconWV';
import FanduelIcon from '@/features/Icons/ProductSpecificIcons/FDIcon';
import MSIcon from '@/features/Icons/ProductSpecificIcons/MSIcon';
import PokerIcon from '@/features/Icons/ProductSpecificIcons/PokerIcon';
import TermsIcon from '@/features/Icons/TermsIcon';

export const iconMapper: Record<IconProductType, IconSubTypeMapper> = {
  fanduel: {
    popup: {
      default: { icon: FanduelGeneralErrorIcon },
      [ERROR_TYPE.INSUFFICIENT_FUNDS]: {
        icon: FanduelOutOfFundsIcon,
        size: 53,
      },
      [POPUP_TYPES.EXIT]: { icon: WarningIcon, size: 53 },
      [ERROR_TYPE.FREE_SPIN_DIALOG_CHOOSE]: { icon: null, size: 53 },
      [ERROR_TYPE.FREE_SPIN_DIALOG_START]: { icon: null, size: 53 },
      [ERROR_TYPE.FREE_SPIN_DIALOG_FINISH]: { icon: null, size: 53 },
    },
    responsible_gambling: {
      default: { icon: ResponsibleGamingIconDefault, size: 32 },
      nj: { icon: ResponsibleGamingIconNJ, size: 32 },
      pa: { icon: ResponsibleGamingIconPA, size: 32 },
      wv: { icon: ResponsibleGamingIconWV, size: 32 },
      terms: { icon: TermsIcon, size: 32.5 },
    },
    logo: { default: { icon: FanduelIcon, size: 30 } },
  },
  mohegansun: {
    popup: {
      default: { icon: GeneralErrorIcon, size: 53 },
      [ERROR_TYPE.INSUFFICIENT_FUNDS]: { icon: OutOfFundsErrorIcon, size: 53 },
      [POPUP_TYPES.EXIT]: { icon: WarningIcon, size: 53 },
      [ERROR_TYPE.FREE_SPIN_DIALOG_CHOOSE]: { icon: null, size: 53 },
      [ERROR_TYPE.FREE_SPIN_DIALOG_START]: { icon: null, size: 53 },
      [ERROR_TYPE.FREE_SPIN_DIALOG_FINISH]: { icon: null, size: 53 },
    },
    responsible_gambling: {
      default: { icon: ResponsibleGamingIconDefault, size: 32 },
      nj: { icon: ResponsibleGamingIconNJ, size: 32 },
      pa: { icon: ResponsibleGamingIconPA, size: 32 },
      wv: { icon: ResponsibleGamingIconWV, size: 32 },
      terms: { icon: TermsIcon, size: 32.5 },
    },
    logo: { default: { icon: MSIcon, size: 30 } },
  },
  poker: {
    popup: {
      default: { icon: PokerLogoPopupError, size: 53 },
      [ERROR_TYPE.INSUFFICIENT_FUNDS]: {
        icon: FanduelOutOfFundsIcon,
        size: 53,
      },
      [POPUP_TYPES.EXIT]: { icon: WarningIcon, size: 53 },
      [ERROR_TYPE.FREE_SPIN_DIALOG_CHOOSE]: { icon: null, size: 53 },
      [ERROR_TYPE.FREE_SPIN_DIALOG_START]: { icon: null, size: 53 },
      [ERROR_TYPE.FREE_SPIN_DIALOG_FINISH]: { icon: null, size: 53 },
    },
    responsible_gambling: {
      default: { icon: ResponsibleGamingIconDefault, size: 53 },
      terms: { icon: TermsIcon, size: 32.5 },
    },
    logo: { default: { icon: PokerIcon, size: 30 } },
  },
};
